import { connect } from 'react-redux';
import queryString from 'query-string'
import MemberDetails from '../components/member/MemberDetails';

const mapStateToProps = (state, ownProps) => {
	const { match :{ params : { personId } } } = ownProps;
	const componentsStr = queryString.parse(ownProps.location.search).components;
	let components;
	if (componentsStr) {
		components = componentsStr.split(",");
	}

	if (personId) {
		const member = state.memberList[state.selectedMemberId];
		if (member && 'currentMember' in member && member.currentMember === false) {
			ownProps.history.push("/");
			return null;
		}
		return {
			member: {...member},
			partyStats: {...state.partyStats},
			cardComponents: components
		};
	} else {
		return null;
	}
};

const ConnectedMemberDetails = connect(mapStateToProps)(MemberDetails);

export default ConnectedMemberDetails;